// Recursively freezes an object/array and everything it holds, so nothing
// downstream can mutate a shared constant either at the top level or in one
// of its nested objects.
function deepFreeze(value) {
  if (value && typeof value === "object" && !Object.isFrozen(value)) {
    Object.values(value).forEach(deepFreeze);
    Object.freeze(value);
  }
  return value;
}

// Fixed, stable module identifiers. These never change even when a client
// renames the module's on-screen label via clients.config.vocabulary — see
// src/label.js. Order here is also the default nav order and the fallback
// order used to pick a landing tab (src/label.js's resolveLandingModule).
export const MODULE_KEYS = deepFreeze(["templates", "reports", "sheets", "specs", "catalog", "jobs"]);

export const MODULE_META = deepFreeze({
  templates: { icon: "📋", adminOnly: true,  defaultLabel: { one: "Template", many: "Templates" } },
  reports:   { icon: "📄", adminOnly: false, defaultLabel: { one: "Report",   many: "Reports" } },
  sheets:    { icon: "🗂", adminOnly: false, defaultLabel: { one: "Sheet",    many: "Sheets" } },
  specs:     { icon: "📑", adminOnly: false, defaultLabel: { one: "Spec",     many: "Specs" } },
  catalog:   { icon: "💲", adminOnly: true,  defaultLabel: { one: "Catalog",  many: "Catalog" } },
  jobs:      { icon: "🧮", adminOnly: false, defaultLabel: { one: "Job",      many: "Jobs" } },
});
